import React from "react";

function Divider() {
	return (
		<div>
			<img src="../assets/img/divider.svg" className="divider" alt="img" />
		</div>
	)
}

export default Divider;
